import React from 'react';
import {
  Box,
  Typography,
  Paper,
  Chip,
  Button
} from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import dayjs from 'dayjs';
import { exportEnrollmentsToCSV } from '../../../utils/exportCSV/exportEnrollments';
import { FileDownload } from '@mui/icons-material';
const EnrollmentsPaymentGrid = ({ enrollments }) => {
  // Calculate dynamic height based on number of rows for enrollments grid
  // const calculateEnrollmentsGridHeight = () => {
  //   const rowHeight = 52; // Default row height
  //   const headerHeight = 56; // Header height
  //   const minHeight = 400; // Minimum height
  //   const maxHeight = 800; // Maximum height
    
  //   if (!enrollments || enrollments.length === 0) {
  //     return minHeight;
  //   }
    
  //   const calculatedHeight = headerHeight + (enrollments.length * rowHeight) + 20; // +20 for padding
  //   return Math.min(Math.max(calculatedHeight, minHeight), maxHeight);
  // };

  // Prepare enrollments data for the datagrid
  const prepareEnrollmentsData = () => {
    if (!enrollments) return [];
    
    return enrollments
      .filter((enrollment) => {
       return enrollment.amount > 0;
      })
      .map((enrollment, index) => {
        const user = enrollment.user || enrollment.userId || {};
        return {
          id: enrollment._id || index,
          courseName: enrollment.course?.name || '-',
          name: `${user.name || '-'} ${user.surname || '-'}`,
          paymentMethod: enrollment.paymentMethod || '-',
          paymentStatus: enrollment.paymentStatusInfo?.isEnrollmentPaid ? 'Pagato' : 'Da Pagare',
          amount: enrollment.amount || '-',
          // enrollmentDate: enrollment.createdAt ? dayjs(enrollment.createdAt).locale('it').format('DD-MMM-YY') : '-',
          enrollmentDate: enrollment.startDate ? dayjs(enrollment.startDate).locale('it').format('MMM YY') : '-',
          nextPaymentDate: enrollment.paymentStatusInfo?.nextPaymentDate ? dayjs(enrollment.paymentStatusInfo.nextPaymentDate).locale('it').format('DD-MMM-YY') : '-',
          paymentsMade: enrollment.paymentStatusInfo?.paymentsMade || 0,
          totalPayments: enrollment.totalPayments || 0,
          paymentsLate: enrollment.paymentStatusInfo?.paymentsLate || 0,
          paymentStatusInfo: enrollment.paymentStatusInfo
        };
      });
  };

  const exportToCSV = () => {
    exportEnrollmentsToCSV(enrollments);
  };

  const enrollmentsColumns = [
    {
      field: 'courseName',
      headerName: 'Corso',
      flex: 1.2,
      minWidth: 120,
      renderCell: (params) => {
        return params.value || '-';
      }
    },
    {
      field: 'name',
      headerName: 'Nome',
      flex: 1.5,
      minWidth: 150,
      renderCell: (params) => {
        return params.value || '-';
      }
    },
    {
      field: 'paymentMethod',
      headerName: 'Metodo Pagamento',
      flex: 1,
      minWidth: 120,
      renderCell: (params) => {
        return params.value || '-';
      }
    },
    {
      field: 'paymentStatus',
      headerName: 'Stato Pagamento',
      flex: 1,
      minWidth: 120,
      renderCell: (params) => {
        const isPaid = params.row.paymentStatusInfo?.isEnrollmentPaid;
        return (
          <Chip
            label={params.value}
            color={isPaid ? 'success' : 'warning'}
            size="small"
            sx={{ fontWeight: 600 }}
          />
        );
      }
    },
    {
      field: 'amount',
      headerName: 'Importo',
      flex: 0.8,
      minWidth: 80,
      renderCell: (params) => {
        return <Typography fontWeight={600}>€{params.value}</Typography>;
      }
    },
    {
      field: 'enrollmentDate',
      headerName: 'A Partire Da',
      flex: 1,
      minWidth: 120,
      renderCell: (params) => {
        return params.value || '-';
      }
    },
    {
      field: 'nextPaymentDate',
      headerName: 'Prossima Scadenza Pagamento',
      flex: 1.2,
      minWidth: 150,
      renderCell: (params) => {
        return params.value || '-';
      }
    },
    {
      field: 'paymentsMade',
      headerName: 'Rate',
      flex: 0.8,
      minWidth: 80,
      renderCell: (params) => {
        return `${params.value}/${params.row.totalPayments}`;
      }
    },
    {
      field: 'paymentsLate',
      headerName: 'In Ritardo',
      flex: 0.8,
      minWidth: 80,
      renderCell: (params) => {
        return (
          <Chip
            label={params.value}
            color={params.value > 0 ? 'error' : 'success'}
            size="small"
            sx={{ fontWeight: 600 }}
          />
        );
      }
    }
  ];

  return (
    <Box sx={{ mt: 4 }}>
      <Typography variant="h6" gutterBottom>
        Report Stato Pagamenti Iscrizioni Corsi
      </Typography>
      
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Panoramica dello stato dei pagamenti per tutte le iscrizioni ai corsi, incluse rate pagate, scadenze e pagamenti in ritardo. Non include i corsi gratuiti. Non include utenti rimossi.
      </Typography>

      <Box sx={{ display: 'flex', gap: 1, mb: 2, justifyContent: 'flex-end' }}>
        <Button
          variant="outlined"
          color="primary"
          startIcon={<FileDownload />}
          onClick={exportToCSV}
          disabled={!enrollments || enrollments.length === 0}
          size="small"
        >
          Esporta CSV
        </Button>
      </Box>

      {/* <Paper sx={{ height: calculateEnrollmentsGridHeight(), width: '100%' }}> */}
      <Paper sx={{ width: '100%' }}>
        <DataGrid
          rows={prepareEnrollmentsData()}
          columns={enrollmentsColumns}
          initialState={{
            pagination: {
              paginationModel: { pageSize: 25, page: 0 },
            },
          }}
          rowsPerPageOptions={[25, 50, 100]}
          disableSelectionOnClick
          getRowId={(row) => row.id}
          sx={{
            '& .MuiDataGrid-cell': {
              borderBottom: '1px solid #e0e0e0',
            },
            '& .MuiDataGrid-columnHeaders': {
              backgroundColor: '#f5f5f5',
              borderBottom: '2px solid #e0e0e0',
            },
          }}
        />
      </Paper>
    </Box>
  );
};

export default EnrollmentsPaymentGrid;
